import Vue from 'vue'

import assetURL from '@/utils/assetURL'

function dataTransformer(supply) {
  const supplyType = supply.supply_type
  const supplyTypeId = supplyType.id || supplyType
  const supplyTypeName = supplyType.name || supplyType

  const unitMeasurement = supply.unit_measurement
  const unitMeasurementId = unitMeasurement.id || unitMeasurement
  const unitMeasurementName = unitMeasurement.name || unitMeasurement
  const unitMeasurementAbbr = unitMeasurement.abbr || unitMeasurement

  const { copies } = supply

  return {
    code: supply.code || '',
    comment: supply.comment,
    id: supply.id,
    image: assetURL(supply.image),
    isActive: supply.is_active,
    isDivisible: supply.is_divisible,
    name: supply.name,
    sctCode: supply.sct_code,
    subFamilyId: supply.subfamily,
    pictograms: supply.pictograms ? supply.pictograms.map((p) => { return { src: assetURL(p.file), ...p } }) : null,
    supplyTypeId,
    supplyTypeName,
    supplyTypeShort: supply.supply_type.short_name,
    copies: copies || [],
    unitMeasurementId,
    unitMeasurementName,
    unitMeasurementAbbr,
    unitWeight: supply.unit_weight

  }
}

export default (id) => {
  return Vue.$http.get(`catalogs/services/supply/${id}/`)
    .then(({ data }) => {
      let transformed = dataTransformer(data[0])
      return transformed 
    })
}


// WEBPACK FOOTER //
// ./src/services/catalog/fetchSupply.js